import DataMap from '../../components/DataMap/DataMap';
import { useStreets } from '../../hooks/fetchStreets';

const StreetCategory = () => {
    const streets = useStreets();
    return (
        <div>
            <DataMap streets = {streets} deviceType = {"streets"}/>
        </div>
    );
};

export default StreetCategory;